import { State } from 'xstate';
import { changePaymentProfile } from './changePaymentProfile';

type ChangePaymentProfileMachine = typeof changePaymentProfile;
type ChangePaymentProfileState = State<ChangePaymentProfileMachine['context']>;

export const getChangePaymentProfileStatus = (
  machineState: ChangePaymentProfileState
) => ({
  isLoading: machineState.matches('changePaymentProfile'),
  isError: machineState.matches('error'),
});

export const getErrorCode = (machineState: ChangePaymentProfileState) => {
  return machineState.context.error;
};

export const changePaymentProfileSelectors = {
  getChangePaymentProfileStatus,
  getErrorCode,
};
